import React from 'react';
import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { CustomAvatar } from '@europrocurement/flexy-components';
import { formatDateWithArticle } from '@europrocurement/l2d-utils';

type CreatedBy = {
    prenom?: string | null;
    nom?: string | null;
    userIdentifier?: string | null;
};

type CheckableTaskRowCreatorSectionProps = {
    createdBy?: CreatedBy | null;
    createdAt?: string | null;
    isMini: boolean;
};

const CheckableTaskRowCreatorSection: React.FunctionComponent<CheckableTaskRowCreatorSectionProps> =
    function ({ createdBy, createdAt, isMini }) {
        const { palette } = useTheme();

        if (!createdBy && !createdAt) return null;

        return (
            <Box
                sx={{
                    display: 'flex',
                    gap: '4px',
                    fontStyle: 'italic',
                    color: palette.grey['700'],
                    alignItems: 'center',
                }}
            >
                {createdBy &&
                    (isMini ? (
                        <Tooltip
                            title={
                                createdAt
                                    ? `Créé par ${createdBy.prenom ?? ''} ${createdBy.nom ?? ''}, ${formatDateWithArticle(createdAt)}`.trim()
                                    : `Créé par ${createdBy.prenom ?? ''} ${createdBy.nom ?? ''}`.trim()
                            }
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    cursor: 'default',
                                }}
                            >
                                <Typography
                                    variant="l2dcaption"
                                    sx={{ fontWeight: 400 }}
                                >
                                    Créé par
                                </Typography>
                                <CustomAvatar
                                    firstName={createdBy.prenom ?? undefined}
                                    lastName={createdBy.nom ?? undefined}
                                    keycloakId={createdBy.userIdentifier ?? null}
                                    sx={{ width: 24, height: 24, fontSize: '0.65rem' }}
                                />
                            </Box>
                        </Tooltip>
                    ) : (
                        <>
                            <Tooltip
                                title={`${createdBy.prenom ?? ''} ${createdBy.nom ?? ''}`.trim()}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <Typography
                                        variant="l2dcaption"
                                        sx={{ fontWeight: 400 }}
                                    >
                                        Créé par
                                    </Typography>
                                    <CustomAvatar
                                        firstName={createdBy.prenom ?? undefined}
                                        lastName={createdBy.nom ?? undefined}
                                        keycloakId={createdBy.userIdentifier ?? null}
                                        sx={{ width: 24, height: 24, fontSize: '0.65rem' }}
                                    />
                                </Box>
                            </Tooltip>
                            {createdAt && (
                                <Typography
                                    variant="l2dcaption"
                                    sx={{ fontWeight: 400 }}
                                >
                                    {formatDateWithArticle(createdAt)}
                                </Typography>
                            )}
                        </>
                    ))}
                {createdAt && !createdBy && (
                    <Typography
                        variant="l2dcaption"
                        sx={{ fontWeight: 400 }}
                    >
                        {formatDateWithArticle(createdAt)}
                    </Typography>
                )}
            </Box>
        );
    };

export default CheckableTaskRowCreatorSection;
